import React, { useState } from "react";
import { FaPrayingHands } from "react-icons/fa";
import Footer from "./Footer";
import "./NeedPrayer.css";

const WEB3FORMS_KEY = "00bb38f1-38dc-4c70-b5ef-0867572bd0da";

const PrayerRequest = () => {
  const [formData, setFormData] = useState({
    name: "",
    prayerRequest: "",
    contactNeeded: "N",
    contactInfo: "",
  });
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "submitting", message: "" });

    const payload = new FormData();
    payload.append("access_key", WEB3FORMS_KEY);
    payload.append("subject", "New Prayer Request for The City Church");
    payload.append("name", formData.name || "Anonymous");
    payload.append("prayerRequest", formData.prayerRequest);
    payload.append("contactNeeded", formData.contactNeeded === "Y" ? "Yes" : "No");
    payload.append("contactInfo", formData.contactInfo);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: payload,
      });
      const result = await response.json();
      if (result.success) {
        setStatus({
          state: "success",
          message:
            "Thank you. Your prayer request has been received, and our prayer team is standing with you.",
        });
        setFormData({ name: "", prayerRequest: "", contactNeeded: "N", contactInfo: "" });
      } else {
        setStatus({ state: "error", message: "Something went wrong. Please try again in a moment." });
      }
    } catch {
      setStatus({ state: "error", message: "We couldn’t send your request. Please check your connection and try again." });
    }
  };

  const submitting = status.state === "submitting";

  return (
    <>
      <section className="prayer">
        <div className="prayer__card tcc-card">
          <span className="prayer__icon"><FaPrayingHands aria-hidden="true" /></span>
          <h1 className="prayer__title">Need prayer?</h1>
          <p className="prayer__intro">
            Whatever you’re facing, you don’t have to face it alone. Share your
            request and our prayer team will lift it up in confidence.
          </p>

          {status.state === "success" && (
            <div className="tcc-alert tcc-alert--success" role="status">{status.message}</div>
          )}
          {status.state === "error" && (
            <div className="tcc-alert tcc-alert--error" role="alert">{status.message}</div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="tcc-field">
              <label className="tcc-label" htmlFor="name">
                Name <span className="tcc-optional">(optional)</span>
              </label>
              <input
                className="tcc-input"
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
                autoComplete="name"
              />
            </div>

            <div className="tcc-field">
              <label className="tcc-label" htmlFor="prayerRequest">Prayer request</label>
              <textarea
                className="tcc-textarea"
                id="prayerRequest"
                name="prayerRequest"
                value={formData.prayerRequest}
                onChange={handleChange}
                placeholder="How can we pray for you?"
                required
              />
            </div>

            <div className="tcc-field">
              <label className="tcc-label" htmlFor="contactNeeded">
                Would you like someone to contact you?
              </label>
              <select
                className="tcc-select"
                id="contactNeeded"
                name="contactNeeded"
                value={formData.contactNeeded}
                onChange={handleChange}
              >
                <option value="N">No, prayer only</option>
                <option value="Y">Yes, please reach out</option>
              </select>
            </div>

            {formData.contactNeeded === "Y" && (
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="contactInfo">
                  Phone or email
                </label>
                <input
                  className="tcc-input"
                  type="text"
                  id="contactInfo"
                  name="contactInfo"
                  value={formData.contactInfo}
                  onChange={handleChange}
                  placeholder="How can we reach you?"
                  required
                />
              </div>
            )}

            <button
              type="submit"
              className="tcc-btn tcc-btn--primary tcc-btn--lg tcc-btn--block"
              disabled={submitting}
            >
              {submitting ? (<><span className="tcc-spinner" aria-hidden="true" /> Sending…</>) : "Send Prayer Request"}
            </button>
          </form>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrayerRequest;
